export default __webpack_public_path__ + "static/media/logoopenpay.894f1b39.jpg";